// src/utils/passwordSecurity.ts
// Updated: 2026-08-20 15:00:00 CDT
// Purpose: Centralize password-form validation and recovery redirect construction.

export const MIN_PASSWORD_LENGTH = 8;

export const validateNewPassword = (
  password: string,
  confirmation: string,
): string | null => {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `Password must contain at least ${MIN_PASSWORD_LENGTH} characters.`;
  }

  if (password !== confirmation) {
    return "The passwords do not match.";
  }

  return null;
};

// Both public hostnames return authentication to Supabase's configured site URL.
// Local development retains its origin and can use a separately allowed URL.
export const authRedirectOrigin = (origin: string): string => {
  const trimmed = origin.replace(/\/$/, "");
  return trimmed === "https://www.tableread.tv" ? "https://tableread.tv" : trimmed;
};

export const buildPasswordResetRedirect = (origin: string): string =>
  `${authRedirectOrigin(origin)}/reset-password`;
